import images from "../../../dist/imgs/approaches/index";

const approachList = [
  {
    heading: "Visual programming with Bubble",
    paragraph:
      "Bubble is the world's leading no-code platform, enabling non-coders to build and scale custom software in dramatically less time and effort.",
    image: images[0],
    stats: [
      { heading: "1m+", description: "Bubble users" },
      { heading: "$100m", description: "Bubble funding" },
      { heading: "5x", description: "Development speed" },
    ],
  },
  {
    heading: "Future-proofing your web app",
    paragraph:
      "Our proprietary Canvas building framework supercharges the Bubble building process, providing clients with beautiful designs, maintainability, and extensibility.",
    image: images[1],
    stats: [
      { heading: "#1", description: "Building framework for Bubble" },
      { heading: "10k+", description: "Products built on Canvas" },
      { heading: "100+", description: "of page and block templates" },
    ],
  },
  {
    heading: "Client-focused and transparent process",
    paragraph:
      "Our clients are at the center of our process. We built our own in-house project portal, also on Bubble, to allow you to collaborate with us each step towards a successful launch.",
    image: images[2],
    stats: [
      { heading: "97%", description: "On-time delivery" },
      { heading: "10k+", description: "Successful client projects" },
      { heading: "100k+", description: "Tasks completed" },
    ],
  },
  {
    heading: "Free training to help you own your product",
    paragraph:
      "The Airdev No-Code Bootcamp is a free online program teaching the next generation of software developers how to build without code",
    image: images[3],
    stats: [
      { heading: "52", description: "Self-guided lessons" },
      { heading: "31k+", description: "Lessons submitted" },
      { heading: "2k+", description: "Satisfied students" },
    ],
  },
  {
    heading: "Top talent to help when you need us",
    paragraph:
      "Building good software requires superior logic and product knowledge, even when building without code. If you feel overwhelmed, rest assured we have your team ready to help.",
    image: images[4],
    stats: [
      { heading: "100+", description: "Team members" },
      { heading: "20+", description: "Countries" },
      { heading: "3%", description: "Acceptance rate" },
    ],
  },
];

export default approachList;
